import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({});
    const [ready, setReady] = useState(false);
    const [role, setRole] = useState();
    const [panel, setPanel] = useState(localStorage.getItem('panel'));
    const [loading, setLoading] = useState(false);
    const [toast, setToast] = useState({show: false});
    const [tempUnlocked, setTempUnlocked] = useState(false);

    return (
        <AuthContext.Provider
            value={{
                auth, setAuth, ready, setReady,
                role, setRole, panel, setPanel,
                loading, setLoading, toast, setToast,
                tempUnlocked, setTempUnlocked
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export default AuthContext;